module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/350-c856ae11685306229018b0b514e9681d.jpg";